// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //desarrollo
  //urlBase: 'http://test.bnp.gob.pe:53491/',
  //urlBase: 'https://localhost:44369/',
  //urlBase: 'http://172.16.8.119:8100/',
  //urlBaseFirmado: 'http://172.16.8.119:8027/',

  // ruta para pruebas en local
  // ng serve --open --host 127.0.0.1 --port 80 --disable-host-check

  //serv pruebas test
   //urlBase: 'http://172.16.89.144:8061/',
   //urlBaseFirmado: 'http://172.16.89.144:8060/',
  //serv utilitario
  //apiUtilitario:'http://172.16.8.119:9095/',


  //prod
  urlBase: 'https://apiemisionconstancias.bnp.gob.pe/',
  urlBaseFirmado: 'https://respuestafirmabit4id.bnp.gob.pe/',

  //serv utilitario
  //apiUtilitario:'https://apiutilitario.bnp.gob.pe/',





  usuarioConstancias:'bnpconstancias',
  claveConstancias:'123***789',


};

